import ApiGo_AuditTrail from "./ApiGo_AuditTrail";
import i18n from '../i18n'; // useTranslation 一般function class 無法使用改狦原生寫。


let status;

/**
 * Api FormData 共用格式 body
 * 
 * @param {Object} Api - Api 共用格式 body參數
 * - Api.url api連結
 * - Api.method http 協定
 * - Api.header 格式
 * - Api.form_data 傳送到伺服器資料
 * - Api.type api 函式名稱(python def 名稱)
 * @param {string} Api.url api連結
 * @param {string} Api.method http 協定
 * @param {string} Api.header 格式
 * @param {string} Api.form_data 傳送到伺服器資料
 * @param {string} Api.type api 函式名稱(python def 名稱)
 */
export default ({ url, method, form_data, type, audit_trial_excluded=false, msg = ""}) => {

    return fetch(url, { // url 請求位置
        method: method || 'GET', //請求方法
        body: form_data || null,
    }).then(res => {
        status = res.status;
        // NOTE: 寫入歷史記錄
        if (method !== null && method !== undefined) {
           
            if (
                method === "PUT" ||
                method === "POST" ||
                method === "DELETE" ||
                method === "PATCH"
            ) {

                const audit_trail_event = "AUDIT_TRAIL.EVENTS." + type.toUpperCase();

                if (res.status === 200 || res.status === 201 || res.status === 202 || res.status === 204) {
                    const action = i18n.t(audit_trail_event, { lng: "zh-TW" }) +
                        (msg ? (" " + msg + " ") : " ") +
                        i18n.t('GLOBAL.STATUS.SUCCESS', { lng: "zh-TW" });

                    if(!audit_trial_excluded){ ApiGo_AuditTrail.postAuditTrail(action, type); }
                } else {
                    const action = i18n.t(audit_trail_event, { lng: "zh-TW" }) +
                        (msg ? (" " + msg + " ") : " ") +
                        i18n.t('GLOBAL.STATUS.FAILURE', { lng: "zh-TW" });

                    ApiGo_AuditTrail.postAuditTrail(action, type);
                }

            }
        }
        if(status === 200 || status === 201 || status === 202 || status === 204){
            if(res.statusText==="No Content"){ return "success" }
            return res.json()
        }else{
            // 報錯 回傳陣列 狀態碼, 狀態訊息
            throw {status:res.status, statusText:res.statusText, response:res.json()}
        }
        
    })
    .catch(res=>{ throw res })
}

export { status };